<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix"><span translate="Kreiraj dokument na osnovu postojećeg"></span></h2>
    </div>
</div>
<div class="modal-body">
  <form [formGroup]="baseFormGroup" class="">

    <div class="form-group row">
      <div class="col-md-12">
        <yt-fw-date-picker-popup formControlName="DatumDokumenta"
                                 name="txtDatumDokumenta"
                                 [Label]="'FAKDOKUMENT.DATDOK.SINGULAR'"
                                 [ngClass]="{'is-invalid': submitted && fc.DatumDokumenta.invalid}">
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.DatumDokumenta.invalid">
          <span *ngFor="let validation of errorMessages.DatumDokumenta">
            <span class="error-message" *ngIf="fc.DatumDokumenta.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
    </div>

    <div class="form-group row" *ngIf="vrstaDokumenta != 'fak-ponuda' && vrstaDokumenta != 'fak-predracun' && vrstaDokumenta !='fak-avansni'">
      <div class="col-md-12">
        <yt-fw-date-picker-popup formControlName="PeriodOd"
                                 name="txtPerioOd"
                                 [Label]="'FAKDOKUMENT.DATUMPROMETAOD.SINGULAR'"
                                 [ngClass]="{'is-invalid': submitted && fc.PeriodOd.invalid}">
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.PeriodOd.invalid">
          <span *ngFor="let validation of errorMessages.PeriodOd">
            <span class="error-message" *ngIf="fc.PeriodOd.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
        </div>
        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
          <span class="error-message"
                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDatumPrometaOd && !this.baseFormGroup.errors.checkControlsDatumPrometaOd.valid">
            <span translate="{{this.baseFormGroup.errors.checkControlsDatumPrometaOd.message}}"></span>
          </span>
        </div>
      </div>
    </div>

    <div class="form-group row" *ngIf="vrstaDokumenta != 'fak-ponuda' && vrstaDokumenta != 'fak-predracun' && vrstaDokumenta !='fak-avansni'">
      <div class="col-md-12">
        <yt-fw-date-picker-popup formControlName="PeriodDo"
                                 name="txtPerioDo"
                                 [Label]="'FAKDOKUMENT.DATUMPROMETADO.SINGULAR'"
                                 [ngClass]="{'is-invalid': submitted && fc.PeriodDo.invalid}">
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.PeriodDo.invalid">
          <span *ngFor="let validation of errorMessages.PeriodDo">
            <span class="error-message" *ngIf="fc.PeriodDo.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
        </div>
        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
          <span class="error-message"
                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDatumPrometaDo && !this.baseFormGroup.errors.checkControlsDatumPrometaDo.valid">
            <span translate="{{this.baseFormGroup.errors.checkControlsDatumPrometaDo.message}}"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4" *ngIf="vrstaDokumenta != 'fak-ponuda' && vrstaDokumenta != 'fak-predracun' && vrstaDokumenta !='faktura-izvozna'">
        <div class="form-check" style="padding-top: 22px">
          <input class="form-check-input"
                 type="checkbox"
                 formControlName="copy_korekcija"
                 id="chkKorekcija">
          <label class="form-check-label" for="chkKorekcija" ngbTooltip="{{'PONOVI.KOREKCIJA.TOOLTIP' | translate }}">
            <span translate="FAKDOKUMENT.KOREKCIJAVREDNOSTIDOKUMENTA.SINGULAR"></span>
          </label>
        </div>
      </div>

      <div class="col-md-4" *ngIf="vrstaDokumenta !='faktura-izvozna'">
        <div class="form-check" style="padding-top: 22px">
          <input class="form-check-input"
                 type="checkbox"
                 formControlName="copy_objekat"
                 id="chkObjekat">
          <label class="form-check-label" for="chkObjekat" ngbTooltip="{{'PONOVI.OBJEKAT.TOOLTIP' | translate }}">
            <span translate="FAKDOKUMENT.KOMITENTOBJEKAT.SINGULAR"></span>
          </label>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-check" style="padding-top: 22px">
          <input class="form-check-input"
                 type="checkbox"
                 formControlName="copy_napomena"
                 id="chkNapomena">
          <label class="form-check-label" for="chkNapomena" ngbTooltip="{{'PONOVI.NAPOMENA.TOOLTIP' | translate }}">
            <span translate="FAKDOKUMENT.NAPOMENA.SINGULAR"></span>
          </label>
        </div>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnOk" (click)="Ok()"><span translate="FW.ACTION.OK"></span></button> 
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span translate="FW.ACTION.CLOSE.ACTION"></span></button>
</div>
